module.exports = __webpack_public_path__ + "img/banner_3.021b2a1f.png";